import React from 'react';
import styles from './Processing.module.scss';
import { ComponentLoader } from '@snsw/react-component-library';

export const Processing = (props) => {
  return (
    <div className={`${styles.mainCont} ${styles.mainContWide}`}>
      <div className={`row`}>
        <div className={`col-12`}>
          <ComponentLoader fullPage label={props.message || 'Loading'} />
        </div>
      </div>
    </div>
  );
};
